import { render, staticRenderFns } from "./RoleSwitcher.vue?vue&type=template&id=458e523d"
import script from "./RoleSwitcher.vue?vue&type=script&lang=js"
export * from "./RoleSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports